<div class="library-header-container">
  <div class="library-header">
    <div class="description">
      <rk-page-title
        [title]="currentBac.translated$ | async"
        [icon]="currentBac?.icon"
      ></rk-page-title>
      <ng-container *ngIf="currentBac.name !== '__CHRONIC__'; else chronics">
        <ng-container
          *ngIf="
            currentBac.name !== '__DEDICATION__' ||
            (planBigger(plan, 'Start') && shoutOutsEnabled)
          "
        >
          <div class="action">
            <div class="buttons">
              <rk-library-upload-track [box]="currentBac"></rk-library-upload-track>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="fullHeader || isCurrentlyFiltered">
          <div class="library-length-search flex justify-between items-end">
            <div
              class="meta"
              *ngIf="
                currentBac.count === displayedTracks &&
                  !(currentSearchValue || isCurrentlyFiltered);
                else filtering
              "
            >
              <span translate [translateParams]="{ count: currentBac.count }"
                >MEDIA.BACS.COUNT</span
              >
              <span> - </span>
              <span translate [translateParams]="getMinutesAndHours(tracksTime)"
                >MEDIA.BACS.TIME</span
              >
            </div>
            <div class="right-side" data-tour="search">
              <div class="search">
                <rk-search-bar #searchBar (inputted)="editSearch($event)"></rk-search-bar>
              </div>
              <rk-library-filter-button [bac]="currentBac"></rk-library-filter-button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #filtering>
  <span
    *ngIf="isCurrentlyFiltered && !currentSearchValue; else search"
    class="filtering"
    [class.hidden]="displayedTracks === null"
    [innerHTML]="
      'MEDIA.TRACK.FILTERING'
        | translate: { displayed: displayedTracks, total: currentBac.count }
    "
  ></span>
</ng-template>

<ng-template #search>
  <span
    class="filtering"
    [innerHTML]="
      'MEDIA.TRACK.SEARCHING'
        | translate: { displayed: displayedTracks, total: currentBac.count }
    "
  ></span>
</ng-template>

<ng-template #chronics>
  <div class="action mb-4">
    <div class="buttons">
      <a [href]="chronicsUrl">
        <rk-button
          btnStyle="orange"
          [label]="'MEDIA.BACS.PLANNING_CHRONICS' | translate"
          [faIcon]="'fa-calendar-alt'"
          [iconSize]="'12px'"
          (click)="clickButton()"
        ></rk-button>
      </a>
    </div>
  </div>
  @if (planBigger(plan, 'Demo')) {
    <div class="meta">
      <span translate [translateParams]="{ count: currentBac.count }"
        >MEDIA.BACS.COUNT_CHRONICS</span
      >
    </div>
  } @else {
    <rk-colored-hint type="info">
      <div class="flex items-center chronics-hint">
        <mat-icon fontSet="fa" fontIcon="fa-crown"></mat-icon>
        <div class="whitespace-normal ml-2" translate>MEDIA.BACS.CHRONICS_READONLY</div>
      </div>
    </rk-colored-hint>
  }
</ng-template>
